import { Injectable } from '@angular/core';
import { Token } from './token.model';

const KEY = 'authToken';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor() { }

  setToken(token: Token): void {
    window.localStorage.setItem(KEY, JSON.stringify(token));
  }

  getToken(): Token {
    return JSON.parse(window.localStorage.getItem(KEY));
  }

  removeToken(): void {
    window.localStorage.removeItem(KEY);
  }
}
